module.exports = __webpack_public_path__ + "media/images/flags/gd-7391bfd04c3b1d608f97d4d7ceb12bd7.svg";